require('../../modules/es6.object.is-extensible');
module.exports = require('../../modules/_core').Object.isExtensible;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/object/is-extensible.js
// module id = 1066
// module chunks = 62